// Theme by default loads a jQuery as dependency of the main script.
// Let's include it using ES6 modules import.
import $ from 'jquery'
import VanillaModal from 'vanilla-modal'
import './lib/modernizr'
import slick from 'slick-carousel'
import axios from 'axios';
import SmoothScroll from 'smooth-scroll';

function toggleSubNav (ev, state) {
  switch (state) {
  case true:
    $('body').addClass('subnav-active')
    break
  default:
    $('body').removeClass('subnav-active')
  }
  ev.currentTarget.setAttribute('aria-expanded', state)
}

function toggleSearchHeader (ev, state) {
  const $form = $(ev.delegateTarget).find('form')
  const $input = $(ev.delegateTarget).find('#search')
  if ($input.val() !== '' && $('body').hasClass('search-visible')) {
    $form.submit()
  } else {
    $('body').toggleClass('search-visible')
    $form.fadeToggle(500, 'swing', () => {
      if ($('body').hasClass('search-visible')) {
        $input.focus()
      }
    })
  }
}

$(document).ready(() => {
  const scroll = new SmoothScroll('a[href*="#"]', {
    offset: $('.banner').innerHeight() + 100
  })

  // toggle subnav on hover
  $('.nav--aria').on('blur mouseleave', '[aria-haspopup="true"]', (ev) => {
    toggleSubNav(ev, false)
  })

  $('.nav--aria').on('focus mouseenter', '[aria-haspopup="true"]', (ev) => {
    toggleSubNav(ev, true)
  })

  // handle search toggle
  $('.search-container').on('click', '.search-toggle', toggleSearchHeader)

  // mobile nav
  if (document.querySelector('.nav-drawer')) {
    const nav = new VanillaModal({
      modal: '.nav-drawer',
      modalInner: '.nav-drawer-inner',
      modalContent: '.nav-drawer-content',
      class: 'nav-visible',
      open: null
    })

    // Open drawer nav modal on Hamburger click
    const $navToggle = $('[data-nav-toggle]')
    if ($navToggle) {
      $navToggle.bind('click', (ev) => {
        const navTarget = $(ev.currentTarget).attr('data-nav-toggle')
        if (!nav.isOpen) {
          nav.open(navTarget)
        } else {
          nav.close(navTarget)
        }
      })
    }
  }

  if (document.querySelector('.testimonials-slider')) {
    $('.testimonials-slider').slick({
      'arrows': false,
      'dots': true,
      'slidesToShow': 1,
  		'accessibility': true,
      'mobileFirst': true,
  		'focusOnSelect': false,
  		'centerMode': false,
      'infinite': true,
      'adaptiveHeight': true,
      'responsive': [
        {
          'breakpoint': 768,
          'settings': {
            'arrows': true
          }
        },
        {
          'breakpoint': 1340,
          'settings': {
            'arrows': true,
            'slidesToShow': 2
          }
        }
      ]
    });
  }

  if (document.querySelector('.posts-slider')) {
    $('.page-template-frontpage .promote--clients .posts-slider').slick({
      'appendArrows': $('.clients-slider-nav'),
      'dots': true,
      'slidesToShow': 1,
  		'accessibility': true,
      'mobileFirst': true,
  		'focusOnSelect': false,
  		'centerMode': false,
      'infinite': true,
      'responsive': [
        {
          'breakpoint': 768,
          'settings': {
            'slidesToShow': 2
          }
        }, {
          'breakpoint': 992,
          'settings': {
            'slidesToShow': 3
          }
        }
      ]
    })
  }

  if (document.querySelector('.modal')) {
    const modal = new VanillaModal({
      modal: '.modal',
      modalInner: '.modal-inner',
      modalContent: '.modal-content',
      class: 'modal-visible',
      open: null,
      onBeforeClose: function() {
        document.getElementById('modalContent').remove()
      }
    });

    document.querySelectorAll('.modalize').forEach(link => {
      link.addEventListener('click', e => {
        e.preventDefault();
        link.classList.add('loading');
        axios.get(link.href)
          .then(resp => {
            const x = document.createElement('div');
            x.innerHTML = resp.data;
            const content = x.querySelector('.section .content');
            const modalClass = link.dataset.modalClass;
            content.setAttribute('id', 'modalContent');
            content.classList.add('hidden');
            document.body.appendChild(content);
            modal.dom.modalContent.classList.add(modalClass);
            modal.open('#modalContent');
            link.classList.remove('loading');
          })
          .catch(err => {
            console.error(err);
          })
      })
    });
  }

  if (document.querySelector('[data-disclosure]')) {
    document.querySelector('[data-disclosure]').addEventListener('click', function (event) {
      var content = document.querySelector('#' + event.target.getAttribute('aria-controls'));
      if (!content) return;
      if (event.target.getAttribute('aria-expanded') === 'true') {
        event.target.setAttribute('aria-expanded', false);
        content.classList.remove('visible');
      } else {
        event.target.setAttribute('aria-expanded', true);
        content.classList.add('visible');
      }

    });
  }

  document.addEventListener( 'wpcf7mailsent', ( event )=> {
    if (typeof ga !== "undefined") {
      ga( 'send', 'event', 'Contact Form ' + event.detail.contactFormId + ' Submitted', 'submit' );
    }
    if ( "366" == event.detail.contactFormId ) { // Invoice Payment Page
      let url = "/invoice-payment/confirm?invoice=[invoice-number]";
      event.detail.inputs.forEach(input => {
        if (input.name == 'amount') {
          url = url.replace(`[${input.name}]`, parseInt(input.value).toFixed(2))
        } else {
          url = url.replace(`[${input.name}]`, input.value)
        }
      })
      window.location = url;
    }
  }, false );
});


// WEBPACK FOOTER //
// ./resources/assets/js/app.js